module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv2512-pc-3c8ccd65e22d174619f4125d67713611.jpg";